import { render, staticRenderFns } from "./CardDesktop.vue?vue&type=template&id=79ce250a&scoped=true&"
import script from "./CardDesktop.vue?vue&type=script&lang=js&"
export * from "./CardDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CardDesktop.vue?vue&type=style&index=0&id=79ce250a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce250a",
  null
  
)

component.options.__file = "CardDesktop.vue"
export default component.exports